(function (angular) {
    'use strict';

    angular.module('app')
        .service('MessageGroupsApi', messageGroupsApi);

    messageGroupsApi.$inject = [
        '$resource',
        'settings'
    ];

    function messageGroupsApi(
        $resource,
        settings
    ) {
        // POST requests only
        var resource = $resource(settings.apiBase + '/group-message-threads');

        return resource;
    }
}(angular));
